import React, { useState } from 'react';
import ContactModal from './ContactModal';
import './LandingPage.css';

function LandingPage({ onLogin, onSignup }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [contactCategory, setContactCategory] = useState('料金・プランについて');

  const openContact = (category) => {
    setContactCategory(category);
    setContactOpen(true);
    setMenuOpen(false);
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <div className="lp">

      {/* ナビゲーション */}
      <nav className="lp-nav">
        <div className="lp-nav-inner">
          <div className="lp-nav-logo">
            <img src="/FACTime_logo_Black.png" alt="FACTime" className="lp-nav-logo-img" />
          </div>
          <div className={`lp-nav-links ${menuOpen ? 'open' : ''}`}>
            <button onClick={() => scrollTo('for-whom')}>対象業務</button>
            <button onClick={() => scrollTo('features')}>機能</button>
            <button onClick={() => scrollTo('ai-manual')}>AIマニュアル</button>
            <button onClick={() => scrollTo('screenshots')}>画面紹介</button>
            <button onClick={() => scrollTo('pricing')}>料金</button>
            <button onClick={() => openContact('導入のご相談')}>お問い合わせ</button>
            <button className="lp-nav-login" onClick={onLogin}>ログイン</button>
            <button className="lp-nav-signup" onClick={onSignup}>無料ではじめる</button>
          </div>
          <button className="lp-hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* ヒーロー */}
      <section className="lp-hero">
        <div className="lp-hero-bg">
          <div className="lp-hero-circle lp-hero-circle-1" />
          <div className="lp-hero-circle lp-hero-circle-2" />
          <div className="lp-hero-circle lp-hero-circle-3" />
        </div>
        <div className="lp-hero-content">
          <div className="lp-hero-badge">オペレーショナルワーカーのための業務管理プラットフォーム</div>
          <h1 className="lp-hero-title">
            事務処理現場の「見えない」を<br />
            <span className="lp-hero-accent">「見える」へ。</span>
          </h1>
          <p className="lp-hero-sub">
            金融・保険事務、事務センター、人事・経理など、決められた手順を確実にこなす現場へ。<br className="lp-br-pc" />
            紙や電話の作業も含めて「誰が・何に・どれだけ」時間を使っているかを記録し、<br className="lp-br-pc" />
            チーム全員で同じ状況を共有できる業務管理プラットフォームです。
          </p>
          <div className="lp-hero-actions">
            <button className="lp-btn-primary" onClick={onSignup}>
              無料ではじめる
              <span className="lp-btn-arrow">→</span>
            </button>
            <button className="lp-btn-secondary" onClick={onLogin}>
              ログイン
            </button>
          </div>
          <p className="lp-hero-note">クレジットカード不要・3ユーザーまで永久無料</p>
        </div>
      </section>

      {/* 特徴バナー */}
      <section className="lp-badges">
        <div className="lp-badges-inner">
          <div className="lp-badge-item">⏱ ワンクリック計測</div>
          <div className="lp-badge-divider" />
          <div className="lp-badge-item">📋 タスク・フォルダ管理</div>
          <div className="lp-badge-divider" />
          <div className="lp-badge-item">👥 チーム一元管理</div>
          <div className="lp-badge-divider" />
          <div className="lp-badge-item">📊 レポート・分析</div>
          <div className="lp-badge-divider" />
          <div className="lp-badge-item">🎬 AIマニュアル作成</div>
          <div className="lp-badge-divider" />
          <div className="lp-badge-item">🔒 セキュアなクラウド</div>
        </div>
      </section>

      {/* 対象：オペレーショナルワーカーとは */}
      <section className="lp-for" id="for-whom">
        <div className="lp-section-inner">
          <div className="lp-section-header">
            <div className="lp-section-label">対象</div>
            <h2>取り残されてきた<br />「オペレーショナルワーカー」<span className="lp-nowrap">のために</span></h2>
            <p className="lp-section-desc">
              企画職や工場・建設などの現場には専用ツールが行き渡った一方で、<br className="lp-br-pc" />
              事務処理の現場はいまもExcel・紙・メールで回っています。FACTimeはこの現場のためにつくりました。
            </p>
          </div>
          <div className="lp-workers">
            {[
              { label: 'ナレッジワーカー', role: '企画・判断が中心', desc: '意思決定や企画・制作が仕事の中心。プロジェクト管理ツールはすでに数多く揃っています。', tools: 'Jira / Notion / Asana など' },
              { label: 'フロントラインワーカー', role: '工場・建設・配送の現場', desc: '物理的な現場での作業が中心。スマホを使った現場管理アプリが広く普及しています。', tools: '現場管理アプリ など' },
            ].map((w) => (
              <div key={w.label} className="lp-worker">
                <div className="lp-worker-label">{w.label}</div>
                <div className="lp-worker-role">{w.role}</div>
                <p>{w.desc}</p>
                <div className="lp-worker-tools">{w.tools}</div>
              </div>
            ))}
            <div className="lp-worker lp-worker--target">
              <div className="lp-worker-badge">FACTimeの対象</div>
              <div className="lp-worker-label">オペレーショナルワーカー</div>
              <div className="lp-worker-role">事務処理・運営業務</div>
              <p>デスクワークでありながら、決められた手順を正確に、大量にこなすことが仕事の中心。合うツールがなく、Excel・紙・メールでの管理が残っています。</p>
              <div className="lp-worker-tools">Excel / メール / チャット / 紙</div>
            </div>
          </div>
        </div>
      </section>

      {/* 課題 */}
      <section className="lp-problems-sec">
        <div className="lp-section-inner">
          <div className="lp-section-header">
            <div className="lp-section-label">課題</div>
            <h2>事務処理現場の<br />3つの「見えない」</h2>
          </div>
          <div className="lp-problems">
            {[
              {
                n: 1, icon: '🔍', title: '紙や電話の作業が\n記録に残らない',
                desc: 'PCの操作ログでは、書類の開封・捺印・電話での確認に移った瞬間に追跡が途切れます。実際にどの作業にどれだけ時間がかかっているのか、誰にも分かりません。',
                tags: ['書類の仕分け', '捺印・押印', '電話での確認', 'ファイリング'],
              },
              {
                n: 2, icon: '📊', title: '進み具合と\n詰まりが見えない',
                desc: '今どの業務が誰の手元にあって、どこで手が止まっているのか。リアルタイムで分からないため、特定の人に負荷が偏り、納期遅れや処理漏れにつながります。',
                tags: ['納期遅れ', '処理漏れ', '負荷の偏り'],
              },
              {
                n: 3, icon: '👥', title: '人の配置が\n経験と勘だのみ',
                desc: '誰に余裕があるかが見えないため、応援や配置換えは管理者の感覚頼み。管理者はExcelの更新や進捗の確認連絡に追われ、現場には不公平感が残ります。',
                tags: ['手作業のExcel集計', '進捗確認の連絡', '属人的な判断'],
              },
            ].map((p) => (
              <div key={p.n} className="lp-problem">
                <div className="lp-problem-n">{p.n}</div>
                <div className="lp-problem-icon">{p.icon}</div>
                <h3>{p.title.split('\n').map((l, i) => <React.Fragment key={i}>{l}{i === 0 && <br />}</React.Fragment>)}</h3>
                <p>{p.desc}</p>
                <div className="lp-tags">{p.tags.map((t) => <span key={t} className="lp-tag">{t}</span>)}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 解決：課題ごとにFACTimeの機能で答える */}
      <section className="lp-solution">
        <div className="lp-section-inner">
          <div className="lp-section-header lp-section-header--light">
            <div className="lp-section-label lp-section-label--light">ソリューション</div>
            <h2>ワンクリックの記録が、<br />チーム全員の共通認識になる</h2>
          </div>
          <div className="lp-solutions">
            {[
              {
                problem: '紙や電話の作業が記録に残らない',
                title: 'どんな作業もワンクリックで記録',
                desc: '「今から書類仕分け」とタスクを選んでボタンを押すだけ。PCの外で行う作業も、そのまま作業時間のデータになります。',
              },
              {
                problem: '進み具合と詰まりが見えない',
                title: '今、誰が何をしているかをリアルタイムで共有',
                desc: 'リアルタイムモニターとガントチャートで、メンバーごとの作業状況と1日の流れがひと目で分かります。タスク別・メンバー別の集計も自動です。',
              },
              {
                problem: '人の配置が経験と勘だのみ',
                title: '目標件数の割り当てで、配置をデータで判断',
                desc: 'メンバーごとに日々のタスクと目標件数を割り当て、完了数と見比べながら進められます。余裕のある人・遅れている業務が分かるので、応援を根拠をもって頼めます。',
              },
              {
                problem: '手順が人に依存して引き継げない',
                title: '操作を録画するだけで手順書を作成',
                desc: 'システム操作の録画をアップロードすると、AIが手順書に書き起こします。新人教育や引き継ぎの資料づくりにかかる手間を減らせます。',
              },
            ].map((s) => (
              <div key={s.title} className="lp-solution-card">
                <div className="lp-solution-problem">{s.problem}</div>
                <div className="lp-solution-arrow">↓</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 活用シーン */}
      <section className="lp-scenes-sec">
        <div className="lp-section-inner">
          <div className="lp-section-header">
            <div className="lp-section-label">活用シーン</div>
            <h2>こんな現場で使われることを<br />想定しています</h2>
          </div>
          <div className="lp-scenes">
            {[
              { icon: '🏦', title: '金融・保険事務', desc: '住宅ローン審査補助、口座開設、本人確認、保険契約事務、書類精査' },
              { icon: '🏢', title: '事務センター', desc: 'データ照合、不備確認、申請処理、複数工程の受託事務' },
              { icon: '👥', title: '人事・労務', desc: '給与計算、社会保険手続き、入退社手続き、勤怠不備確認' },
              { icon: '🧾', title: '経理・購買', desc: '請求書処理、入金消込、支払照合、購買申請' },
              { icon: '💻', title: 'IT運用・管理事務', desc: 'アカウント発行、権限申請、各種問い合わせ処理、運用チェック' },
            ].map((s) => (
              <div key={s.title} className="lp-scene">
                <div className="lp-scene-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 機能紹介 */}
      <section className="lp-features" id="features">
        <div className="lp-section-inner">
          <div className="lp-section-header">
            <div className="lp-section-label">機能</div>
            <h2>現場の見える化に必要な機能が<br />揃っています</h2>
          </div>
          <div className="lp-features-grid">
            <div className="lp-feature-card lp-feature-card--highlight">
              <div className="lp-feature-new">NEW</div>
              <div className="lp-feature-icon lp-icon-indigo">🎬</div>
              <div>
                <h3>AIで操作マニュアルを自動作成</h3>
                <p>パソコンの操作を録画した動画をアップロードするだけで、AIが画面の流れを読み取り、ボタン名や項目名入りの手順書を自動で作成します。作成したマニュアルは画面上で編集でき、テキスト・Word・PDFでダウンロード可能。履歴からいつでも見返せるので、業務の引き継ぎや新人教育の資料づくりにかかる手間を大きく減らせます。</p>
              </div>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon lp-icon-blue">⏱</div>
              <h3>ワンクリック作業計測</h3>
              <p>タスクを選んでボタンを押すだけで計測スタート。停止も簡単で、記録し忘れを防ぎます。スリープ防止機能で長時間作業も安心。</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon lp-icon-green">📋</div>
              <h3>階層型タスク管理</h3>
              <p>フォルダとタスクを最大3階層まで整理。色分けやCSVインポートで大量のタスクも効率よく管理できます。</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon lp-icon-purple">📊</div>
              <h3>ダッシュボード・分析</h3>
              <p>タスク別・ユーザー別の作業時間をグラフで可視化。ガントチャートやリアルタイムモニターでチームの状況を把握できます。</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon lp-icon-orange">👥</div>
              <h3>チームユーザー管理</h3>
              <p>管理者がメンバーを招待・管理。部署・役職・入社日などのプロフィールも一元管理できます。</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon lp-icon-cyan">📅</div>
              <h3>タスク割り当て</h3>
              <p>日付ごとにユーザーへタスクを割り当て。目標件数を設定して、進捗をリアルタイムで追跡できます。</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon lp-icon-pink">☁️</div>
              <h3>クラウド完全対応</h3>
              <p>ブラウザさえあればどこからでもアクセス可能。データはクラウドに安全に保存されます。</p>
            </div>
          </div>
        </div>
      </section>

      {/* AI操作マニュアル生成 */}
      <section className="lp-manual" id="ai-manual">
        <div className="lp-section-inner">
          <div className="lp-section-header">
            <div className="lp-section-label">NEW　AIマニュアル作成</div>
            <h2>操作を録画するだけで、<br />手順書が完成します</h2>
          </div>
          <div className="lp-manual-body">
            <div className="lp-manual-text">
              <ol className="lp-manual-steps">
                <li>
                  <span className="lp-manual-step-num">1</span>
                  <div>
                    <strong>操作を録画してアップロード</strong>
                    <p>いつもの操作を画面録画し、タイトルを付けてアップロードするだけ。</p>
                  </div>
                </li>
                <li>
                  <span className="lp-manual-step-num">2</span>
                  <div>
                    <strong>AIが手順を書き起こし</strong>
                    <p>画面の流れを読み取り、ボタン名や入力欄の名前入りで、番号付きの操作手順にまとめます。</p>
                  </div>
                </li>
                <li>
                  <span className="lp-manual-step-num">3</span>
                  <div>
                    <strong>編集・ダウンロード・共有</strong>
                    <p>画面上でそのまま修正でき、テキスト・Markdown・Word・PDFで出力。作ったマニュアルは履歴からいつでも見返せます。</p>
                  </div>
                </li>
              </ol>
              <ul className="lp-manual-uses">
                <li>業務の引き継ぎ資料</li>
                <li>新人教育・研修</li>
                <li>社内システムの操作手順書</li>
              </ul>
              <p className="lp-manual-note">※ アップロードした動画は30日後に自動で削除されます。作成したマニュアル（文章）は削除されません。</p>
            </div>
            <div className="lp-manual-shot">
              <img src="/screenshot_manual.png" alt="操作マニュアル生成画面：録画動画から作成された経費申請の手順" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* 画面と機能の紹介 */}
      <section className="lp-showcase" id="screenshots">
        <div className="lp-section-inner">
          <div className="lp-section-header">
            <div className="lp-section-label">画面紹介</div>
            <h2>直感的なUIで、<br />今日からすぐに使いこなせます</h2>
          </div>
          <div className="lp-showcase-row">
            <div className="lp-showcase-text">
              <div className="lp-showcase-label">⏱ タイマー</div>
              <h3>ボタンを押すだけで、<br />作業時間を記録できます</h3>
              <ul className="lp-showcase-points">
                <li>
                  <strong>タスクを選んでワンクリック</strong>
                  <p>いま取りかかる作業を選び「START WORKING」を押すだけ。面倒な入力はいりません。</p>
                </li>
                <li>
                  <strong>休憩も切り替えるだけ</strong>
                  <p>休憩ボタンで作業時間と休憩時間を分けて記録。タスクを切り替えれば自動で記録が分かれます。</p>
                </li>
                <li>
                  <strong>フォルダで迷わない</strong>
                  <p>取引先や案件ごとのフォルダにタスクがまとまっているので、目的の作業がすぐ見つかります。</p>
                </li>
              </ul>
            </div>
            <div className="lp-showcase-shot">
              <img src="/screenshot_timer.png" alt="タイマー画面：タスクを選んで計測を開始" loading="lazy" />
            </div>
          </div>
          <div className="lp-showcase-row lp-showcase-row--reverse">
            <div className="lp-showcase-text">
              <div className="lp-showcase-label">📊 ダッシュボード</div>
              <h3>誰が・何に・どれだけ。<br />ひと目で分かります</h3>
              <ul className="lp-showcase-points">
                <li>
                  <strong>期間をワンクリックで切り替え</strong>
                  <p>今日・昨日・今週・先週・今月・先月から選ぶだけ。任意の期間も指定できます。</p>
                </li>
                <li>
                  <strong>タイムラインで流れを把握</strong>
                  <p>いつ・どの作業をしていたかを、メンバーごとに色分けして表示します。</p>
                </li>
                <li>
                  <strong>集計サマリーで比較</strong>
                  <p>総作業時間・タスク数・稼働日数・タスク別の時間を一覧にし、並び替えて比べられます。</p>
                </li>
              </ul>
            </div>
            <div className="lp-showcase-shot">
              <img src="/screenshot_dashboard.png" alt="ダッシュボード画面：ユーザーごとの作業時間をタイムラインと集計表で比較" loading="lazy" />
            </div>
          </div>
          <div className="lp-showcase-row">
            <div className="lp-showcase-text">
              <div className="lp-showcase-label">📋 タスク管理</div>
              <h3>会社や案件ごとに、<br />作業をすっきり整理</h3>
              <ul className="lp-showcase-points">
                <li>
                  <strong>フォルダで階層管理</strong>
                  <p>取引先・案件ごとにフォルダを作り、その中にタスクをまとめられます。</p>
                </li>
                <li>
                  <strong>CSVでまとめて登録・出力</strong>
                  <p>タスクはCSVで一括インポート・出力ができ、既存の一覧からすぐに移行できます。</p>
                </li>
                <li>
                  <strong>使わないタスクはアーカイブ</strong>
                  <p>終わった案件はアーカイブして画面をすっきり。必要になればいつでも戻せます。</p>
                </li>
              </ul>
            </div>
            <div className="lp-showcase-shot">
              <img src="/screenshot_tasks.png" alt="タスク管理画面：フォルダとタスクの一覧" loading="lazy" />
            </div>
          </div>
          <div className="lp-showcase-row lp-showcase-row--reverse">
            <div className="lp-showcase-text">
              <div className="lp-showcase-label">👥 ユーザー管理</div>
              <h3>メンバーの追加も権限も、<br />管理者がまとめて設定</h3>
              <ul className="lp-showcase-points">
                <li>
                  <strong>管理者・一般ユーザーの役割分け</strong>
                  <p>管理者だけがタスクやメンバーを設定でき、一般ユーザーは記録に集中できます。</p>
                </li>
                <li>
                  <strong>CSVで一括登録</strong>
                  <p>部署・役職も含めて、メンバーをCSVでまとめて登録できます。</p>
                </li>
                <li>
                  <strong>日々の目標件数を割り当て</strong>
                  <p>メンバーごとに「今日はこのタスクを何件」と割り当てると、タイマー画面で完了数と目標を確認しながら進められます。</p>
                </li>
              </ul>
            </div>
            <div className="lp-showcase-shot">
              <img src="/screenshot_users.png" alt="ユーザー管理画面：メンバーの一覧と役割" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* 料金 */}
      <section className="lp-pricing" id="pricing">
        <div className="lp-section-inner">
          <div className="lp-section-header">
            <div className="lp-section-label">料金</div>
            <h2>シンプルな料金体系</h2>
            <p className="lp-pricing-note">クレジットカード不要で今すぐ無料開始。<br />有料プランの料金はチームの規模に合わせてご案内しますので、お気軽にお問い合わせください。</p>
          </div>
          <div className="lp-pricing-grid">
            <div className="lp-pricing-card">
              <div className="lp-pricing-plan">無料プラン</div>
              <div className="lp-pricing-price">
                <span className="lp-price-amount">無料</span>
              </div>
              <p className="lp-pricing-desc">小さなチームや試用に</p>
              <ul className="lp-pricing-features">
                <li>✅ ユーザー 3人まで</li>
                <li>✅ タスク 3つまで</li>
                <li>✅ 全機能を利用可能</li>
                <li>✅ クラウド保存</li>
                <li>✅ 期限なし</li>
              </ul>
              <button className="lp-pricing-btn lp-pricing-btn--free" onClick={onSignup}>
                無料ではじめる
              </button>
            </div>
            <div className="lp-pricing-card lp-pricing-card--popular">
              <div className="lp-pricing-badge">おすすめ</div>
              <div className="lp-pricing-plan">有料プラン</div>
              <div className="lp-pricing-price">
                <span className="lp-price-amount lp-price-amount--contact">お問い合わせください</span>
              </div>
              <p className="lp-pricing-desc">成長するチームに</p>
              <ul className="lp-pricing-features">
                <li>✅ ユーザー 10人単位で追加</li>
                <li>✅ タスク 無制限</li>
                <li>✅ 全機能を利用可能</li>
                <li>✅ 料金はご利用人数に合わせてご案内</li>
                <li>✅ 導入・運用のご相談も承ります</li>
              </ul>
              <button className="lp-pricing-btn lp-pricing-btn--paid" onClick={() => openContact('料金・プランについて')}>
                料金をお問い合わせ
              </button>
              <p className="lp-pricing-example">
                まずは無料プランでお試しいただけます
              </p>
            </div>
          </div>
          <div className="lp-pricing-faq">
            <div className="lp-faq-item">
              <strong>Q. 有料プランの料金はいくらですか？</strong>
              <p>ご利用人数などに合わせてご案内しております。<button type="button" className="lp-faq-link" onClick={() => openContact('料金・プランについて')}>お問い合わせフォーム</button>からお気軽にご連絡ください。</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="lp-cta">
        <div className="lp-cta-inner">
          <h2>今すぐ無料ではじめましょう</h2>
          <p>3ユーザーまで永久無料。クレジットカード不要。</p>
          <button className="lp-btn-primary lp-btn-large" onClick={onSignup}>
            無料アカウントを作成
            <span className="lp-btn-arrow">→</span>
          </button>
        </div>
      </section>

      {/* フッター */}
      <footer className="lp-footer">
        <div className="lp-footer-inner">
          <div className="lp-footer-logo">
            <img src="/FACTime_logo_White.png" alt="FACTime" className="lp-nav-logo-img" />
          </div>
          <p className="lp-footer-copy">© 2026 FACTime. All rights reserved.</p>
          <div className="lp-footer-links">
            <button onClick={onLogin} className="lp-footer-link">ログイン</button>
            <button onClick={onSignup} className="lp-footer-link">新規登録</button>
            <button onClick={() => openContact('その他')} className="lp-footer-link">お問い合わせ</button>
            <a href="https://spinningbird.co.jp/" target="_blank" rel="noopener noreferrer" className="lp-footer-link">運営会社</a>
          </div>
        </div>
      </footer>

      <ContactModal
        open={contactOpen}
        onClose={() => setContactOpen(false)}
        defaultCategory={contactCategory}
      />
    </div>
  );
}

export default LandingPage;
